import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  props: ['aprId', 'revisao', 'novoTemplateClonado'],
  name: 'templateFilter',
  components: {},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataTemplateAPR: []
    }
  },
  mounted () {
    this.onLoad()
  },
  watch: {
    novoTemplateClonado (value) {
      if (value !== undefined && value !== null) {
        loading.push()
        aprTemplate.GetAPRTemplatePainelById(value.id, value.revisao)
          .then((Response) => {
            loading.pop()
            this.dataTemplateAPR = Response.data.data[0]
          })
      }
    }
  },
  methods: {
    onLoad (value) {
      if (value !== undefined && value !== null) {
        loading.push()
        aprTemplate.GetAPRTemplatePainelById(this.aprId, value)
          .then((Response) => {
            loading.pop()
            this.dataTemplateAPR = Response.data.data[0]
          })
      } else {
        loading.push()
        aprTemplate.GetAPRTemplatePainelById(this.aprId, this.revisao)
          .then((Response) => {
            loading.pop()
            this.dataTemplateAPR = Response.data.data[0]
          })
      }
    },
    DefinirResponsaveis () {
      const payload = {
        id: this.aprId,
        elaborador: this.dataTemplateAPR.elaborador,
        aprovador: this.dataTemplateAPR.aprovador,
        observacao: this.dataTemplateAPR.observacao
      }
      aprTemplate.DefinirResponsaveisTemplateApr(payload)
        .then((Response) => {
          loading.pop()
          console.log('sucesso')
          toast.success('Responsáveis definidos com sucesso')
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    UpdateTemplate (tipo) {
      if (tipo === 'aprovar') {
        aprTemplate.AprovacaoTemplateByApr(this.aprId)
          .then((Response) => {
            loading.pop()
            this.revisao = Response.data.result
            this.onLoad(this.revisao)
            this.$emit('AtualizaAbas', this.revisao)
            toast.success('Template aprovado com sucesso')
          })
          .catch((Error) => {
            loading.pop()
          })
      } else if (tipo === 'reprovar') {
        aprTemplate.ReprovaTemplateByApr(this.aprId)
          .then((Response) => {
            loading.pop()
            this.revisao = Response.data.result
            this.onLoad(this.revisao)
            this.$emit('AtualizaAbas', this.revisao)
            toast.success('Template reprovado com sucesso')
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/PanelByApr/PanelByApr.js